// profiles/EditProfileBasic.jsx

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import EditProfileStyles from "./EditProfile.styles";
import useUserProfile from "../../hooks/useUserProfile";

const EditProfileBasic = () => {
  const { profileData, loading, updateProfile } = useUserProfile();
  const [formData, setFormData] = useState(profileData || { fullName: '', email: '', phone: '' });
  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    setFormData(profileData);
  }, [profileData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Format phone number as user types (XXX-XXX-XXXX)
  const handlePhoneChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '');
    const limitedDigits = digits.slice(0, 10);
    let formatted = '';
    if (limitedDigits.length > 0) {
      formatted = limitedDigits.slice(0, 3);
    }
    if (limitedDigits.length > 3) {
      formatted += '-' + limitedDigits.slice(3, 6);
    }
    if (limitedDigits.length > 6) {
      formatted += '-' + limitedDigits.slice(6, 10);
    }
    setFormData({ ...formData, phone: formatted });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await updateProfile(formData);
    setSuccessMessage(true); // Trigger success message
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", marginTop: "2rem" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={EditProfileStyles.container}>
      <Typography variant="h4" sx={EditProfileStyles.title}>
        Edit Profile
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              label="Full Name"
              fullWidth
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              sx={EditProfileStyles.textField}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email"
              fullWidth
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              sx={EditProfileStyles.textField}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Phone Number"
              fullWidth
              name="phone"
              value={formData.phone || ''}
              onChange={handlePhoneChange}
              sx={EditProfileStyles.textField}
              placeholder="(555) 123-4567"
              helperText="Enter 10-digit phone number"
              inputProps={{ inputMode: "tel", maxLength: 12 }}
            />
          </Grid>
        </Grid>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={EditProfileStyles.submitButton}
        >
          Save Changes
        </Button>
      </form>

      {/* Success Snackbar Message */}
      <Snackbar
        open={successMessage}
        autoHideDuration={4000}
        onClose={() => setSuccessMessage(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={() => setSuccessMessage(false)} severity="success" sx={{ width: "100%" }}>
          🎉 Profile updated successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EditProfileBasic;
